"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoformatMarks = void 0;
var _plateBasicMarks = require("@udecode/plate-basic-marks");
var autoformatMarks = exports.autoformatMarks = [{
  mode: 'mark',
  type: [_plateBasicMarks.MARK_BOLD, _plateBasicMarks.MARK_ITALIC],
  match: '***'
}, {
  mode: 'mark',
  type: [_plateBasicMarks.MARK_UNDERLINE, _plateBasicMarks.MARK_ITALIC],
  match: '__*'
}, {
  mode: 'mark',
  type: [_plateBasicMarks.MARK_UNDERLINE, _plateBasicMarks.MARK_BOLD],
  match: '__**'
}, {
  mode: 'mark',
  type: [_plateBasicMarks.MARK_UNDERLINE, _plateBasicMarks.MARK_BOLD, _plateBasicMarks.MARK_ITALIC],
  match: '___***'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_BOLD,
  match: '**'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_UNDERLINE,
  match: '__'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_ITALIC,
  match: '*'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_ITALIC,
  match: '_'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_STRIKETHROUGH,
  match: '~~'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_SUPERSCRIPT,
  match: '^'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_SUBSCRIPT,
  match: '~'
}, {
  mode: 'mark',
  type: _plateBasicMarks.MARK_CODE,
  match: '`'
}];